<template>
    <administrative>
        <card-header :title="faculty.first_name+' '+faculty.middle_name+' '+faculty.last_name"></card-header>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <h2 class="uppercase text-lg">Last Paid Salaries</h2>
            <breeze-table :fields="fields" :items="salaries"
                          :action="{'text':'Add Salary','url':route('administrative.faculty.salary.create',faculty.id)}"
                          :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Faculty Salary')"
                          :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Faculty')">
                <template #month="data">
                    {{ convertMonthYear(data.item.month) }}
                </template>
                <template #action="data">
                    <breeze-button :type="'button'"
                                   v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Faculty')"
                                   @click="showSalaryDetails(data.item)">View
                    </breeze-button>
                </template>
            </breeze-table>
        </div>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg mt-4">
            <!-- <h2 class="uppercase text-lg">Attendance</h2>
            <v-calendar :attributes='attrs' :columns="$screens({ default: 1, lg: 2 })" is-expanded /> -->
            <div>
                <div class="flex justify-between">
                    <h2>Performance Overview</h2>
                    <v-date-picker v-model="selectedDateRange" is-range :modelConfig="modelConfig" :masks="masks">
                        <template v-slot="{ inputValue, togglePopover }">
                            <div class="flex items-center">
                                <button
                                    class="p-2 bg-blue-100 border border-blue-200 hover:bg-blue-200 text-blue-600 rounded-l focus:bg-blue-500 focus:text-white focus:border-blue-500 focus:outline-none"
                                    @click="togglePopover()"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        class="w-4 h-4 fill-current"
                                    >
                                        <path
                                            d="M1 4c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4zm2 2v12h14V6H3zm2-6h2v2H5V0zm8 0h2v2h-2V0zM5 9h2v2H5V9zm0 4h2v2H5v-2zm4-4h2v2H9V9zm0 4h2v2H9v-2zm4-4h2v2h-2V9zm0 4h2v2h-2v-2z"
                                        ></path>
                                    </svg>
                                </button>
                                <input
                                    :value="inputValue.start +'-'+inputValue.end"
                                    class="bg-white text-gray-700 w-full py-1 px-2 appearance-none border rounded-r focus:outline-none focus:border-blue-500"
                                    disabled
                                />
                            </div>
                        </template>
                    </v-date-picker>
                </div>
                <div class="flex flex-wrap">
                    <template v-if="!loadingPerformance">
                        <div class="min-w-0 rounded-lg shadow-xs overflow-hidden bg-gray-100 w-1/6 m-4"
                             v-for="(sb,index) in performance" :key="index">
                            <PerformanceStatus :name="index" :value="sb"
                                               :admission="faculty"
                                               :branch-id="branchid"
                                               type="faculty"
                            />
                            <!--                                <div class="p-4 flex items-center">-->
                            <!--                                    <div>-->
                            <!--                                        <p class="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">-->
                            <!--                                            {{ capitalize(index) }}-->
                            <!--                                        </p>-->
                            <!--                                        <p class="text-lg font-semibold text-gray-700 dark:text-gray-200">-->
                            <!--                                            {{ sb }} {{index == 'present' || index == 'absent' ? '%':''}}-->
                            <!--                                        </p>-->
                            <!--                                    </div>-->
                            <!--                                </div>-->
                        </div>
                    </template>
                    <template v-else>
                        <div class="flex h-20 justify-center items-center w-full">
                            <div>Loading...</div>
                        </div>
                    </template>

                </div>

                <div class="flex items-center justify-between space-x-8 text-base my-5">
                    <h2 class="">Attendance Overview</h2>
                    <div class="flex space-x-8">
                        <div class="flex flex-row space-x-2 py-2">
                            <div class="w-6 h-6 flex items-end justify-center">
                                <span class="w-1.5 h-1.5 rounded-full" style="background:#3182ce"></span>
                            </div>
                            <div>Present</div>
                        </div>
                        <div class="flex flex-row space-x-2 py-2">
                            <div class="w-6 h-6 rounded-full" style="border:2px solid #c53030"></div>
                            <div>Absent</div>
                        </div>
                        <div class="flex flex-row space-x-2 py-2">
                            <div class="w-6 h-6 rounded-full" style="background:#bee3f8"></div>
                            <div>Holiday</div>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col mb-8">
                    <template v-if="!loadingPerformance">

                        <v-calendar :attributes='attrs' is-expanded/>

                    </template>
                    <template v-else>
                        <div class="flex h-20 justify-center items-center w-full">
                            <div>Loading...</div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <model :isOpen="salaryDetails?true:false">
            <template #body>
                <div class="flex-1">
                    <div class="flex space-x-4 justify-between">
                        <div class="p-4 shadow-sm rounded-md space-x-4 border border-gray-200"><span
                            class="text-sm uppercase">Paid</span><span
                            class="text-lg font-semibold">₹{{ salaryDetails.total }}</span></div>
                        <div class="p-4 shadow-sm rounded-md space-x-4 border border-gray-200"><span
                            class="text-sm uppercase">In Hand</span><span
                            class="text-lg font-semibold">₹{{ salaryDetails.in_hand }}</span></div>
                        <div class="p-4 shadow-sm rounded-md space-x-4 border border-gray-200"><span
                            class="text-sm uppercase">Month</span><span
                            class="text-lg font-semibold">{{ convertMonthYear(salaryDetails.month) }}</span></div>
                    </div>
                    <breeze-table :fields="innerFields" :items="salaryDetails.details"
                                  :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Faculty')">
                        <template #type="data">
                            {{ data.item.type == 1 ? 'Addition' : 'Subtraction' }}
                        </template>
                    </breeze-table>
                </div>
            </template>
            <template #buttons>
                <div>
                    <breeze-button :type="'button'" @click="hideSalaryDetails()">Close</breeze-button>
                </div>
            </template>
        </model>
    </administrative>
</template>

<script>
import Administrative from '@/Pages/Administrative/Administrative'
import BreezeTable from '@/Components/Table'
import BreezeButton from '@/Components/Button'
import CardHeader from '@/Components/CardHeader'
import Model from '@/Components/Model'
import PerformanceStatus from "@/Pages/Internal/Admission/PerformanceStatus.vue";

export default {
    components: {
        PerformanceStatus,
        Administrative,
        BreezeTable,
        BreezeButton,
        CardHeader,
        Model
    },
    props: ['faculty', 'salaries', 'attendance'],
    data() {
        return {
            fields: [{'key': 'total', 'label': 'Total'}, {'key': 'in_hand', 'label': 'In Hand'}, {
                'key': 'month',
                'label': 'Month Year'
            }, {'key': 'action', 'label': 'Action'}],
            innerFields: [{'key': 'title', 'label': 'Title'}, {'key': 'value', 'label': 'Amount'}, {
                'key': 'type',
                'label': 'Type'
            }, {'key': 'remark', 'label': 'Remark'}],
            salaryDetails: null,
            attrs: [],
            performance: [],
            loadingPerformance: false,
            selectedDateRange: {
                start: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-1',
                end: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-31'
            },
            modelConfig: {
                type: 'string',
                mask: 'YYYY-MM-DD', // Uses 'iso' if missing
            },
            masks: {
                input: 'DD/MM/YYYY'
            },
            branchid: localStorage.branchId,
        }
    },
    methods: {
        showSalaryDetails(data) {
            this.salaryDetails = data;
        },
        hideSalaryDetails() {
            this.salaryDetails = null;
        },
        getPerformance() {
            let query = '?start=' + this.selectedDateRange.start + '&end=' + this.selectedDateRange.end + '&branch=' + this.branchid;
            this.loadingPerformance = true;
            this.attrs = [];
            window.axios.get(route('administrative.faculty.performance', this.faculty.id) + query)
                .then(async res => {
                    let data = await res.data;
                    this.performance = data['overview'];
                    data['attendance']['present'].forEach((pr) => {
                        this.attrs.push({
                            key: pr.id,
                            dot: true,
                            dates: new Date(pr.attendance_at)
                        })
                    })
                    data['attendance']['absent'].forEach((ab) => {
                        this.attrs.push({
                            key: ab.id,
                            highlight: {
                                color: 'red',
                                fillMode: 'outline',
                            },
                            dates: new Date(ab.attendance_at)
                        })
                    })
                    data['attendance']['holidays'].forEach((hl) => {
                        this.attrs.push({
                            key: hl.id,
                            highlight: {
                                color: 'blue',
                                fillMode: 'light',
                            },
                            popover: {
                                label: hl.title
                            },
                            dates: hl.to_date ? {start: new Date(hl.from_date), end: new Date(hl.to_date)} : new Date(hl.from_date)
                        })
                    })
                    this.loadingPerformance = false;
                });
        },
    },
    watch: {
        selectedDateRange(v) {
            this.getPerformance();
        }
    },
    beforeMount() {
        // this.getAttendances()
        this.getPerformance();

    },
}
</script>
<style>
.vc-container {
    width: 100% !important;
}
</style>
